export default [
  { name: 'question', label: 'Question', component: 'input' },
  {
    name: 'sectionType',
    label: 'Section',
    component: 'select',
    options: GLOBALS.testing.sections[1]
  }
];
